<script setup>
  import LayoutHeaderRight from '@/features/layout/components/LayoutHeaderRight.vue'
  import HamburgerMenuMobile from '@/features/layout/components/hamburgerMobile/HamburgerMenuMobile.vue'
  import { useLayoutStore } from '@/features/layout/useLayoutStore.js'
  import Breadcrumb from '@/features/ui/components/Breadcrumb.vue'
  import { useBreakpoint } from '@/features/ui/hooks/useBreakpoint.js'

  const layoutStore = useLayoutStore()
  const { isMobile } = useBreakpoint()
</script>

<template>
  <header class="layout-header">
    <span v-if="layoutStore.showBackButton" class="hamburger-button-mobile">
      <i class="pi pi-chevron-left" @click.prevent="layoutStore.backButtonListener"></i>
    </span>
    <span v-if="isMobile" class="hamburger-button-mobile">
      <i class="pi pi-bars" @click.prevent="layoutStore.toggleSidebar()"></i>
    </span>

    <Breadcrumb v-if="layoutStore.breadcrumbs.length" v-model="layoutStore.breadcrumbs" />

    <div id="layout-header-right-section" class="to-right">
      <LayoutHeaderRight />
    </div>

    <HamburgerMenuMobile v-if="isMobile && layoutStore.sidebarOpened" />
  </header>
</template>

<style lang="scss" scoped>
  .layout-header {
    display: flex;
    gap: 10px;
    border-bottom: 1px solid var(--fm-ui-header-border-bottom-color);
    background: var(--fm-ui-header-background-color);
    align-items: center;
    height: var(--fm-ui-header-height);
    color: var(--fm-ui-header-color);
    position: fixed;
    top: 0;
    left: var(--fm-ui-content-panel-margin-left, 0);
    right: 0;
    z-index: 90;
    transition: all 0.3s;
  }

  .to-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 10px;
    height: 100%;
  }

  .hamburger-button-mobile {
    margin-left: 20px;
    cursor: pointer;
  }
</style>
